export enum ENV {
  PROD = "OZE_PROD",
  DEV = "OZE_DEV",
}